import { LoadingButton } from "@mui/lab";
import { Grid, IconButton, MenuItem, Typography } from "@mui/material";
import {
  EQualityCheckingConditionType,
  EQualityCheckingConditionValue,
  IQualityConditionInProcessCheckDetail,
} from "model";
import PreviewIcon from "@mui/icons-material/Preview";
import EditIcon from "@mui/icons-material/Edit";
import { I18nTranslator, translations } from "utils/i18n";
import { FormTextField } from "components/atoms";
import { Camera } from "@mui/icons-material";

export const QualitySelect = (props: {
  title: string;
  titleEn?: string;
  value: string;
  type: EQualityCheckingConditionType;
  image?: string;
  onAttachImageClick: () => void;
  onViewImageClick: () => void;
  onEditImageClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  imageRequired?: boolean;
  index: number;
}) => {
  return (
    <Grid flex={1} container flexDirection={"column"}>
      <Typography variant="h6">
        {props.title} <span style={{ color: "red" }}>*</span>
        <Typography color={"grey"}>{props.titleEn}</Typography>
      </Typography>
      <Grid flex={1} container flexDirection="row" spacing={2}>
        <Grid item xs={9}>
          {props.type === EQualityCheckingConditionType.Predefined ? (
            <FormTextField
              id={`qualityCheckingConditions.${props.index}.value`}
              select
              required
              disabled={props.disabled}
              label=""
            >
              {QUALITY.map((e) => (
                <MenuItem key={e.value} value={e.value}>
                  {I18nTranslator(e.name)}
                </MenuItem>
              ))}
            </FormTextField>
          ) : (
            <FormTextField
              id={`qualityCheckingConditions.${props.index}.value`}
              // value={_value}
              required
              label={""}
              // onChange={(e) => props.onValueChange(e.target.value)}
              fullWidth
              // placeholder={props.title}
              disabled={props.disabled}
            />
          )}
        </Grid>
        <Grid item container xs={3}>
          {props.image ? (
            <Grid flex={1} item container>
              <Grid
                item
                xs={6}
                container
                alignItems="center"
                justifyContent="center"
              >
                <IconButton
                  color="primary"
                  disabled={props.loading}
                  onClick={props.onViewImageClick}
                  style={{ height: "100%" }}
                >
                  <PreviewIcon />
                </IconButton>
              </Grid>
              <Grid
                item
                xs={6}
                container
                alignItems="center"
                justifyContent="center"
              >
                <IconButton
                  color="primary"
                  disabled={props.loading || props.disabled}
                  onClick={props.onEditImageClick}
                  style={{ height: "100%" }}
                >
                  <EditIcon />
                </IconButton>
              </Grid>
            </Grid>
          ) : (
            <Grid flex={1} position={"relative"}>
              <LoadingButton
                variant="outlined"
                color="primary"
                loading={false}
                startIcon={<Camera />}
                disabled={props.loading || props.disabled}
                onClick={props.onAttachImageClick}
                style={{ height: "100%", padding: 0, width: "100%" }}
              >
                {I18nTranslator(
                  translations.inProcessCheckReportDetail.capturePhoto
                )}{" "}
                {props.imageRequired && (
                  <Typography color={"red"} fontSize={"24px"}>
                    *
                  </Typography>
                )}
              </LoadingButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

const QUALITY: IQualityConditionInProcessCheckDetail[] = [
  {
    name: translations.inProcessCheckReportDetail.statusValue.yes,
    value: EQualityCheckingConditionValue.Yes.toString(),
  },
  {
    name: translations.inProcessCheckReportDetail.statusValue.no,
    value: EQualityCheckingConditionValue.No.toString(),
  },
  {
    name: translations.inProcessCheckReportDetail.statusValue.noUse,
    value: EQualityCheckingConditionValue.NoUse.toString(),
  },
];
